export function convertInstagramUsernameToURL(instagramProfileUrl) {
  const instagramUrlRegex =
    /http(s)?:\/\/(www\.)?(instagram)\.com\/[A-z0-9_\-.]+\/?/;
  const instagramDefaultUrl = 'https://www.instagram.com/';
  let profile = null;

  if (!instagramProfileUrl.match(instagramUrlRegex))
    profile = `${instagramDefaultUrl}${instagramProfileUrl}`;

  return profile;
}
